import React from "react";
import { DteSystemStatusDTO } from "../../types/dte/system/DteSystemTypes";

interface Props {
  form: DteSystemStatusDTO | null;
}

const DteSystemStatusOverview: React.FC<Props> = ({ form }) => {
  const isManual = form?.manualContingencyEnabled === true;

  return (
    <div className="p-5 rounded-lg border border-stroke bg-white shadow-sm dark:border-strokedark dark:bg-boxdark">

      <p className="text-sm text-gray-600 dark:text-gray-300 mb-2">
        Estado actual del sistema DTE:
      </p>

      <div className="inline-flex items-center">
        {isManual ? (
          <span className="inline-flex items-center rounded px-3 py-1 text-sm font-medium bg-[#DC3545] text-white">
            🔴 Modo Contingencia Activado (Manual)
          </span>
        ) : (
          <span className="inline-flex items-center rounded px-3 py-1 text-sm font-medium bg-[#3CA745] text-white">
            🟢 Operando Normalmente
          </span>
        )}
      </div>

    </div>
  );
};

export default DteSystemStatusOverview;
